import styled from 'styled-components';
import { TableCell } from 'ui/tableCell';
import { body2, spacing, textColors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledTableCell = styled(TableCell)`
  height: ${spacing.x4};
  vertical-align: middle;
  max-width: ${pxToRem(360)};
  &[data-first-column='true'] {
    padding-left: ${spacing.double};
  }
`;

export const CreatedByWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${spacing.half};
`;

export const DisplayWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  word-break: break-word;
`;

export const SecondTier = styled.div`
  ${body2};
  color: ${textColors.textSecondary};
  line-height: ${spacing.base};
  font-size: ${spacing.threeQuarter};
  white-space: nowrap;
`;
